module.exports = "/assets/data/607cbd14753bb91778d3cda3c5a085fd-DN35.data.json";